import React from "react";
import { Box, Typography, alpha } from "@mui/material";
import { useTranslation } from "react-i18next";
import { teamMessageSnippet } from "../utils/teamMessageUtils";

const TeamQuotedBlock = ({ authorName, message, variant = "reply", isOwn = false, onClick }) => {
  const { t } = useTranslation("team");
  const isForward = variant === "forward";
  const accent = isForward ? "secondary.main" : "primary.main";

  return (
    <Box
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
      sx={{
        mb: 0.5,
        pl: 1,
        py: 0.45,
        pr: 0.65,
        borderLeft: 3,
        borderColor: accent,
        borderRadius: 1.25,
        bgcolor: (th) =>
          isOwn
            ? alpha(th.palette.common.white, 0.16)
            : alpha(th.palette.primary.main, th.palette.mode === "dark" ? 0.14 : 0.07),
        cursor: onClick ? "pointer" : "default",
        maxWidth: "100%",
        ...(onClick
          ? {
              "&:hover": {
                bgcolor: (th) =>
                  isOwn
                    ? alpha(th.palette.common.white, 0.22)
                    : alpha(th.palette.primary.main, th.palette.mode === "dark" ? 0.2 : 0.11),
              },
            }
          : {}),
      }}
    >
      {isForward ? (
        <Typography
          variant="caption"
          sx={{ display: "block", fontWeight: 700, color: accent, mb: 0.25 }}
        >
          {t("forwardedLabel")}
          {message?.spaceName ? ` · ${message.spaceName}` : ""}
        </Typography>
      ) : null}
      <Typography variant="caption" sx={{ display: "block", fontWeight: 700, opacity: 0.9 }}>
        {authorName || t("unknownAuthor")}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          opacity: 0.85,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {teamMessageSnippet(message, { t })}
      </Typography>
    </Box>
  );
};

export default TeamQuotedBlock;
